import { useGetCitiesRequest } from "@/api/useGetCitiesRequest";
import { SelectOptions } from "../select-options";
import { useFormikContext } from "formik";
import { OptionType } from "../select";
import { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";

export default function SelectCityFlow({
  onSelect,
}: {
  onSelect: (selectedValue) => void;
}) {
  const { values } = useFormikContext<{ regionId: OptionType | null }>();
  const selectRef = useRef<any>(null);
  const t = useTranslations();

  const [firstLettersCityName, setFirstLettersCityName] = useState("");

  useEffect(() => {
    setFirstLettersCityName("");
    selectRef.current?.resetSearch();
  }, [values.regionId]);

  const { data } = useGetCitiesRequest({
    regionId: values?.regionId?.id,
    firstLettersCityName: firstLettersCityName,
  });

  const options = data?.data?.data
    ? data?.data?.data?.map((city) => {
        return {
          id: city.cityId,
          mainText: city.cityName,
        };
      })
    : [];

  return (
    <SelectOptions
      ref={selectRef}
      options={options}
      onSelect={onSelect}
      searchPlaceholder={t("search_for_city")}
      takeSearchValue={setFirstLettersCityName}
      translation={false}
    />
  );
}
